export default "__VITE_ASSET__7a1caf81__"